import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { CircularProgress } from "@mui/material";
import { SurveyServices } from "../services/SurveyServices";
import DoughnutChart from "./DoughnutChat";
import SearchIcon from "../assets/searchIcon.svg";

import "./SurveyQuestionsReport.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
const SurveyQuestionsReport = () => {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);

  const [searchKey, setSearchKey] = useState("");
  const searchTimeRef = useRef();
  const handleSearch = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };

  const getQuestionsReport = async () => {
    try {
      const res = await SurveyServices.getSurveyQuestionsReport();
      setReport(res?.data?.surveyReport);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    getQuestionsReport();
  }, [searchKey]);

  console.log("report:", report);
  return (
    <div className="questions-report-box">
      {" "}
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp;Survey Questions Report
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">Survey Questions Report</div>
        <div className="flex gap-2 items-center">
          <div
            style={{ border: "1px solid #E4E4E4" }}
            className="flex items-center gap-2 bg-white rounded-[8px] px-4 py-[6px] "
          >
            <img src={SearchIcon} alt="search-icon" />
            <input
              type="text"
              placeholder="Search anything"
              style={{ border: "0" }}
              className="outline-none"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid #E7E7E7",
          marginBottom: "20px",
        }}
      />
      {loading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          {report &&
            Object.keys(report)
              ?.filter((key) => report[key]?.questionDetails)
              ?.map((key, idx) => (
                <DoughnutChart chartData={report[key]} index={idx} />
              ))}
        </div>
      )}
    </div>
  );
};

export default SurveyQuestionsReport;
